import { createSagaActionTypes } from "../../../utils/actionFactory";

export const REQUEST_NEW_USER = "REQUEST_NEW_USER";

export const actions = createSagaActionTypes("REQUEST_USER", [REQUEST_NEW_USER]);
